import { http as abyssHttp } from '@uhg-abyss/web/tools/http';
import { config } from '@uhg-abyss/web/tools/config';
import { event } from '@uhg-abyss/web/tools/event';
import { getMessage } from '../messages';

const getCode = (response) => {
  const data = response.data || {};

  if (data.faultCode) {
    return data.faultCode;
  }
  if (data.errorCode) {
    return data.errorCode;
  }
  if (data.code) {
    return data.code;
  }
  if (response.code) {
    return response.code;
  }

  if (data.errors) {
    return data.errors.map((err) => err.code).join(',');
  }

  if (data.error && data.error.errors) {
    return data.error.errors.map((err) => err.code).join(',');
  }
  if (data.error) {
    return data.error.code;
  }

  return response.status || 'NoResponse';
};

const getError = (response, isLagoonErr) => {
  const code = getCode(response);
  const id = response.requestId;
  const messageId = code ? `${id}[${code}]` : `${id}`;

  let message;

  if (typeof response.getMessage === 'function') {
    message = response.getMessage();
  }

  if (!message && code) {
    message = getMessage(`${id}[${code}]`, '', isLagoonErr);

    if (!message) {
      message = getMessage(`default-error[${code}]`, '', isLagoonErr);
    }
  }

  if (!message) {
    message = getMessage(id, '', isLagoonErr);
    if (!message) {
      message = getMessage('default-error') || messageId;
    }
  }

  return { code, message };
};

const http = (options) => {
  const eventData = event.getData();
  const httpOptions = {
    ...options,
    headers: {
      ...options.headers,
      uuid: eventData.uuid,
      'x-xss-protection': '1',
      'content-security-policy': `default-src 'none'; img-src 'self'; script-src 'unsafe-inline'; style-src 'self'`,
      'referrer-policy': 'origin',
      'x-content-type-options': 'nosniff',
    },
  };

  if (config('APP_ENV') === 'local') {
    delete httpOptions.withCredentials;
  }

  if (httpOptions.retry !== false) {
    httpOptions.retry = {
      ...httpOptions.retry,
      onRetryAttempt: (opts, response) => {
        response.requestId = httpOptions.id;
        response.resourceId = httpOptions.resource;
        const errorData = getError(response);
        event('API_TRANSACTION_ERROR', {
          duration: response.duration,
          status: response.status,
          endpoint: response.endpoint,
          resourceId: response.resourceId,
          code: errorData.code,
          message: errorData.message,
        });

        if (options.onRetryAttempt) {
          options.onRetryAttempt(opts, response);
        }
      },
    };
  }

  return abyssHttp(httpOptions)
    .then((response) => {
      response.requestId = httpOptions.id;
      response.resourceId = httpOptions.resource;

      if (!response.cached) {
        event('API_TRANSACTION_SUCCESS', {
          duration: response.duration,
          status: response.status,
          endpoint: response.endpoint,
          resourceId: response.resourceId,
        });
      }
      return response;
    })
    .catch((response) => {
      response.requestId = httpOptions.id;
      response.resourceId = httpOptions.resource;
      const responseData = response.data || {};
      const errorData = getError(response);

      event('API_TRANSACTION_ERROR', {
        duration: response.duration,
        status: response.status,
        endpoint: response.endpoint,
        resourceId: response.resourceId,
        code: errorData.code,
        message: errorData.message,
      });

      throw {
        ...response,
        data: {
          ...responseData,
          ...errorData,
        },
      };
    });
};

Object.assign(http, abyssHttp);

export { http, getError };
